import Technologies from "../components/website/Technologies/Technologies";
import Layout from '../layouts/Layout'
import { Helmet } from 'react-helmet';
import { Link } from 'gatsby';
import config from '../website-config';
const url = typeof window !== 'undefined' ? window.location.href : '';
const TechnologyPage = () => (
  <Layout>
    <Helmet>
      <title>Technologies we use:BizDamn(Wordpress and Web Development Company in Delhi) </title>
      <meta name="description" content='BizDamn Team is versed with top notch technologies and framework to create Premium Websites for your Business' />
      <meta property="og:type" content="website" />
      <meta property="og:title" content='Technologies We Use:BizDamn(Wordpress and Web Development Company in Delhi)' />
      <meta name="keywords" content={`${config.keyword}`} />
      <meta property="og:description" content={`${config.description}`} />
      <meta property="og:url" content={`${config.siteUrl}`} />
      <meta property="og:image:width" />
      <meta property="og:image:height" />
      <script type="application/ld+json">



        {`
         {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
            "itemListElement": [{
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://bizdamn.tech/"
            },{
              "@type": "ListItem",
              "position": 2,
              "name": "Technologies we use for Web Development",
              "item": "https://bizdamn.tech/technologies"
            }]
          },
          {
            "@context": "https://schema.org/",
            "@type": "WebPage",
            "name": "Technologies we use for Wordpress and Web Development",
            "speakable":
            {
             "@type": "SpeakableSpecification",
             "xPath": [
               "/html/head/title",
               "/html/head/meta[@name='description']/@content"
               ]
             },
            "url": ${url}
            }
          `}
      </script>
    </Helmet>
    {/* Breadcrumbs */}
    <section className="breadcrumbs">
      <div className="container">
        <div className="d-flex justify-content-between align-items-center">
          <ol>
            <li><Link to='/'>Home</Link></li>
            <li>Technologies We Use</li>
          </ol>
        </div>
      </div>
    </section>
    <Technologies />
  </Layout>
)

export default TechnologyPage
